import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_CurrentStation } from 'redux/modules/currentStation/Actions'
import { TCurrentStation } from 'redux/modules/currentStation/TReducer'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'

const { post } = RequestMethods()

export interface ISagaWorker_CreateStation {
  parkingId: number
  stationCode: string
  serialNumber: string
  imei: string
  idHigh: string
  idMiddle: string
  idLow: string
}

export default function* SagaWorker_CreateStation(action: PayloadAction<ISagaWorker_CreateStation>) {
  yield put(Actions_CurrentStation.store.showLoader())

  try {
    const data = {
      ...action.payload,
      parkingId: +action.payload.parkingId,
    }
    //------------------------- Create station ---------------------------//
    yield call(async () => await post<TCurrentStation>('/stations', data))

    yield put(Actions_Modals.store.hideModal())
    yield put(Actions_Notifications.store.setNotification({ message: 'Station successfully created', type: 'Success' }))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_CurrentStation.store.hideLoader())
  }
}
